import { CSSProperties } from 'react';

import { Paragraph2 } from 'inpock-ui-react';
import { theme } from 'inpock-ui-react';

import * as S from './styled';
interface BetweenStringProps {
  label: string;
  content: string;
  lineClamp?: number;
  labelColor?: theme.ColorAlias;
  labelFontWeight?: 'regular' | 'bold';
  valueColor?: theme.ColorAlias;
  sx?: CSSProperties;
  size?: 'small' | 'normal';
}

export function OrderInfoLine(props: BetweenStringProps) {
  return (
    <S.Container style={props.sx} size={props.size}>
      <div className="title">
        <Paragraph2 color={props.labelColor || 'gray500'}>{props.label}</Paragraph2>
      </div>
      <div style={{ textAlign: 'end' }}>
        <Paragraph2
          color={props.valueColor || 'gray800'}
          className={props.labelFontWeight ? `text-${props.labelFontWeight}` : 'text-bold'}
          lineClamp={props.lineClamp || 1}
        >
          {props.content}
        </Paragraph2>
      </div>
    </S.Container>
  );
}

export function OrderCompleteInfoLine(props: BetweenStringProps) {
  return (
    <S.Container style={props.sx}>
      <div style={{ minWidth: '76px' }}>
        <Paragraph2 color="gray500">{props.label}</Paragraph2>
      </div>
      <div style={{ marginLeft: '37px', textAlign: 'end' }}>
        <Paragraph2
          color={props.valueColor || 'gray800'}
          fontWeight="bold"
          lineClamp={props.lineClamp}
        >
          {props.content}
        </Paragraph2>
      </div>
    </S.Container>
  );
}
